<template>
  <div>
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-card
        height="48"
        flat
        class="transparent-background-color mb-1"
        v-if="
          timeSnackbar && accountInfo && accountInfo.remain_expired_days <= 30
        "
      >
        <v-snackbar
          absolute
          :timeout="-1"
          top
          color="danger"
          text
          v-model="timeSnackbar"
          min-width="100%"
          class="pl-2"
          v-if="accountInfo && accountInfo.remain_expired_days <= 30"
        >
          <span v-if="accountInfo && accountInfo.remain_expired_days <= 0">
            {{ $t("Top.expired") }}
          </span>
          <span v-else>
            {{
              $t("Top.time_expired_content", [accountInfo.remain_expired_days])
            }}
          </span>

          <template v-slot:action="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              small
              text
              class="px-0 py-0 caption font-weight-bold grey--text"
              color="danger"
              @click.stop="timeSnackbar = false"
              v-if="accountInfo && accountInfo.remain_expired_days > 0"
            >
              <v-icon small class="pe-1">fa-times</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
      </v-card>
      <v-card
        height="48"
        flat
        class="transparent-background-color mb-1"
        v-if="
          smsSnackbar &&
          settings &&
          settings.sms_remain_notice &&
          settings.sms_remain <= 30
        "
      >
        <v-snackbar
          absolute
          :timeout="-1"
          top
          color="danger"
          text
          v-model="smsSnackbar"
          min-width="100%"
          class="pl-2"
          v-if="settings && settings.sms_remain <= 30"
        >
          <span>{{
            $t("Top.sms_remain_notice", [
              settings.sms_remain == "" || settings.sms_remain == null
                ? 0
                : settings.sms_remain,
            ])
          }}</span>
          <template v-slot:action="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              small
              text
              class="px-0 py-0 caption font-weight-bold grey--text"
              color="danger"
              @click.stop="smsSnackbar = false"
              v-if="settings && settings.sms_remain > 0"
            >
              <v-icon small class="pe-1">fa-times</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
      </v-card>
      <v-card
        height="48"
        flat
        class="transparent-background-color mb-1"
        v-if="
          snackbar &&
          alerts.length &&
          settings &&
          settings.shop_psi_add_cost_type
        "
      >
        <span @click="$router.push('/alerts')">
          <v-snackbar
            absolute
            :timeout="-1"
            top
            color="danger"
            text
            v-model="snackbar"
            min-width="100%"
            class="pl-2"
            v-if="alerts.length && settings && settings.shop_psi_add_cost_type"
          >
            {{ alerts[0] ? alerts[0].content : "" }}
            <template v-slot:action="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                small
                text
                class="px-0 py-0 caption font-weight-bold grey--text"
                color="danger"
                @click.stop="snackbar = false"
              >
                <v-icon small class="pe-1">fa-times</v-icon>
              </v-btn>
            </template>
          </v-snackbar>
        </span>
      </v-card>
      <v-row class="mx-2 my-1">
        <v-col cols="12" sm="6" md="4">
          <v-card
            class="mt-6"
            :href="intelligenceReportsUrl"
            target="intelligenceReports"
            @click="reportType = 1"
          >
            <v-sheet
              class="v-sheet--offset mx-auto"
              color="green"
              elevation="3"
              max-width="calc(100% - 32px)"
            >
              <v-sparkline
                :labels="labels"
                :value="ordersCountByHourValue"
                color="white"
                line-width="2"
                padding="16"
              ></v-sparkline>
            </v-sheet>

            <v-card-text class="mt-n3 pt-0 pb-1">
              <v-list-item class="px-0">
                <v-list-item-content
                  class="subheading font-weight-normal grey--text"
                  >{{ $t("Top.orders_total_count") }}
                </v-list-item-content>
                <v-list-item-content
                  class="d-flex justify-end px-0 py-1 title font-weight-bols mb-2"
                  >{{ ordersTotal.orders_total_count }}
                </v-list-item-content>
              </v-list-item>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-card
            class="mt-6"
            :href="intelligenceReportsUrl"
            target="intelligenceReports"
            @click="reportType = 1"
          >
            <v-sheet
              class="v-sheet--offset mx-auto"
              color="orange"
              elevation="3"
              max-width="calc(100% - 32px)"
            >
              <v-sparkline
                :labels="labels"
                :value="ordersTotalByHourValue"
                color="white"
                line-width="2"
                padding="16"
              ></v-sparkline>
            </v-sheet>

            <v-card-text class="mt-n3 pt-0 pb-1">
              <v-list-item class="px-0">
                <v-list-item-content
                  class="subheading font-weight-normal grey--text"
                  >{{ $t("Top.orders_total_order_price") }}
                </v-list-item-content>
                <v-list-item-content
                  class="d-flex justify-end px-0 py-1 title font-weight-bols mb-2"
                  >{{ $t("Global.money")
                  }}{{ ordersTotal.orders_total_order_price }}
                </v-list-item-content>
              </v-list-item>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          md="4"
          :hidden="
            accountInfo &&
            accountInfo.version &&
            accountInfo.version.stock_type == 1
          "
        >
          <v-card
            class="mt-6"
            :href="intelligenceReportsUrl"
            target="intelligenceReports"
            @click="reportType = 2"
          >
            <v-sheet
              class="v-sheet--offset mx-auto"
              color="blue"
              elevation="3"
              max-width="calc(100% - 32px)"
            >
              <v-sparkline
                :labels="labels"
                :value="stockOrdersCountByHourValue"
                color="white"
                line-width="2"
                padding="16"
              ></v-sparkline>
            </v-sheet>
            <v-card-text class="mt-n3 pt-0 pb-1">
              <v-list-item class="px-0">
                <v-list-item-content
                  class="subheading font-weight-normal grey--text"
                  >{{ $t("Top.stock_orders_total_count") }}
                </v-list-item-content>
                <v-list-item-content
                  class="d-flex justify-end px-0 py-1 title font-weight-bols mb-2"
                  >{{ stockOrdersTotal.total_count }}
                </v-list-item-content>
              </v-list-item>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="4" class="d-block d-md-none">
          <v-card>
            <v-card-title>
              {{ $consts.shopName() }}
              <v-spacer />
              <v-chip small label filter class="mx-1" color="primary">
                {{ $t("$datetime.shortcuts.thisMonth") }}
              </v-chip>
            </v-card-title>
            <v-divider />
            <v-card-text class="mt-n3 pt-0 pb-1">
              <v-list-item class="px-0">
                <v-list-item-content class="justify-center">
                  <v-card-title class="justify-center">6</v-card-title
                  >{{ $t("Top.shops.active_shops", [$consts.shopName()]) }}
                </v-list-item-content>
                <v-list-item-content class="justify-center">
                  <v-card-title class="justify-center">2</v-card-title
                  >{{ $t("Top.shops.new_shops", [$consts.shopName()]) }}
                </v-list-item-content>
              </v-list-item>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="4" class="d-block d-md-none">
          <ToDos class="mb-6" :todos="todos" />
        </v-col>
        <v-col
          cols="12"
          md="8"
          :hidden="
            accountInfo &&
            accountInfo.version &&
            accountInfo.version.stock_type == 1
          "
        >
          <v-card>
            <v-tabs
              v-model="tab"
              height="64"
              class="ms-3"
              background-color="transparent"
            >
              <!-- <v-tab
                v-for="tabTitle in materialTabTitles"
                :key="tabTitle.title"
              >
                <v-card-title class="pa-0">
                  {{ tabTitle.title }}
                </v-card-title>
              </v-tab> -->
              <v-tab v-show="Errors.length">
                <v-card-title class="pa-0">
                  {{ $t("Top.PushError.title") }}
                </v-card-title>
              </v-tab>
              <v-tab v-show="OrderToPurchaseErrors.length">
                <v-card-title class="pa-0">
                  {{ $t("Top.orderToPurchaseError.title") }}
                </v-card-title>
              </v-tab>
              <v-tab>
                <v-card-title class="pa-0">
                  {{ $t("Top.nearday_materials") }}
                </v-card-title>
              </v-tab>
              <v-tab>
                <v-card-title class="pa-0">
                  {{ $t("Top.expired_materials") }}
                </v-card-title>
              </v-tab>
              <v-tab>
                <v-card-title class="pa-0">
                  <v-btn
                    x-small
                    @click="edit_date_flg = true"
                    v-if="edit_date_flg == false"
                    class="text-h6"
                    outlined
                  >
                    {{ noOrderDate }}
                  </v-btn>
                  <span v-if="edit_date_flg == false">
                    {{ $t("Top.noOrderShopsWarning_input") }}
                  </span>

                  <v-text-field
                    type="number"
                    v-model="noOrderDate"
                    @keyup.enter="saveNoOrderDate()"
                    style="width: 10px"
                    v-if="edit_date_flg == true"
                  />
                  <span v-if="edit_date_flg == true">
                    {{ $t("Top.noOrderShopsWarning_input") }}
                  </span>
                </v-card-title>
              </v-tab>
              <v-tab v-show="maxStockMaterials.length">
                <v-card-title class="pa-0">
                  {{ $t("Top.max_stock_materials") }}
                </v-card-title>
              </v-tab>
              <v-tab v-show="minStockMaterials.length">
                <v-card-title class="pa-0">
                  {{ $t("Top.min_stock_materials") }}
                </v-card-title>
              </v-tab>
              <v-tab v-show="neardayShops.length">
                <v-card-title class="pa-0">
                  {{ $t("Top.nearday_shop_psi") }}
                </v-card-title>
              </v-tab>
              <v-tab v-show="expiredShops.length">
                <v-card-title class="pa-0">
                  {{ $t("Top.expired_shop_psi") }}
                </v-card-title>
              </v-tab>
            </v-tabs>
            <v-card-text>
              <v-tabs-items v-model="tab">
                <v-tab-item v-show="Errors.length">
                  <v-data-table
                    :headers="errorsHeaders"
                    :items="Errors"
                    class="pb-2"
                    :footer-props="$t('$config.top-footer-props')"
                  >
                    <template v-slot:item.order_code="{ item }">
                      <span
                        v-if="
                          deliveryErrors.length &&
                          deliveryErrors[0].errors.length &&
                          item.type == 2
                        "
                      >
                        {{ deliveryErrors[0].errors[0].order_code + " ..." }}
                      </span>
                      <span v-else-if="item.type == 1 && pushErrors.length">
                        {{ pushErrors[0].order_code + " ..." }}
                      </span>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn
                        small
                        outlined
                        color="info"
                        class="px-2 me-2"
                        @click.stop="
                          item.type == 1
                            ? (pushErrFlg = true)
                            : (deliveryErrFlg = true)
                        "
                      >
                        <v-icon x-small class="pe-1">fa-align-left</v-icon>
                        {{ $t("Opt.details") }}
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-tab-item>
                <!-- 订单转采购错误 -->
                <v-tab-item v-show="OrderToPurchaseErrors.length">
                  <v-data-table
                    :headers="OrderToPurchaseErrorsHeaders"
                    :items="OrderToPurchaseErrors"
                    class="pb-2"
                    :footer-props="$t('$config.top-footer-props')"
                  >
                    <template v-slot:item.actions="{ item }">
                      <v-btn
                        small
                        outlined
                        color="info"
                        class="px-2 me-2"
                        @click.stop="orderToPurchaseErrorView(item.order_id)"
                      >
                        <v-icon x-small class="pe-1">fa-align-left</v-icon>
                        {{ $t("Opt.details") }}
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-tab-item>
                <v-tab-item>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    align-self="center"
                    v-show="settings && neardayMaterials.length > 0"
                  >
                    <v-row dense align="center" class="search-controls">
                      <v-spacer />
                      <v-btn
                        small
                        color="print"
                        dark
                        @click.stop="getMaterials(2)"
                        class="ms-1"
                      >
                        <v-icon x-small class="pe-1">fa-file-export</v-icon>
                        {{ $t("Export.export", [$t("Top.nearday_materials")]) }}
                      </v-btn>
                    </v-row>
                  </v-col>
                  <v-data-table
                    :headers="neardayMaterialsHeaders"
                    :items="neardayMaterials"
                    multi-sort
                    class="pb-2"
                    :footer-props="$t('$config.top-footer-props')"
                  >
                    <template v-slot:item.expired_date="{ item }">
                      <span class="red--text">
                        {{ item.expired_date | diffDate }}
                      </span>
                    </template>
                  </v-data-table>
                </v-tab-item>
                <v-tab-item>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    align-self="center"
                    v-show="settings && expiredMaterials.length > 0"
                  >
                    <v-row dense align="center" class="search-controls">
                      <v-spacer />
                      <v-btn
                        small
                        color="print"
                        dark
                        @click.stop="getMaterials(1)"
                        class="ms-1"
                      >
                        <v-icon x-small class="pe-1">fa-file-export</v-icon>
                        {{ $t("Export.export", [$t("Top.expired_materials")]) }}
                      </v-btn>
                    </v-row>
                  </v-col>
                  <v-data-table
                    :headers="expiredMaterialsHeaders"
                    :items="expiredMaterials"
                    multi-sort
                    class="pb-2"
                    :footer-props="$t('$config.top-footer-props')"
                  >
                    <template v-slot:item.expired_date="{ item }">
                      <span class="red--text">
                        {{ item.expired_date | diffDate }}
                      </span>
                    </template>
                  </v-data-table>
                </v-tab-item>
                <v-tab-item>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    align-self="center"
                    v-show="settings && noOrderShops.length > 0"
                  >
                    <v-row dense align="center" class="search-controls">
                      <v-spacer />
                      <v-btn
                        small
                        color="orange"
                        dark
                        @click.stop="refreshnNOrderShops(true)"
                        class="ms-1"
                        v-if="
                          $permission.permissionAllow('Shops', 'topShopForbid')
                        "
                      >
                        {{ $t("Top.NoOrderShopsFields.shopStatusStop") }}
                      </v-btn>
                      <v-btn
                        small
                        color="print"
                        dark
                        @click.stop="noOrderShopsWarningExport()"
                        class="ms-1"
                      >
                        <v-icon x-small class="pe-1">fa-file-export</v-icon>
                        {{
                          $t("Export.export", [
                            $t("Top.noOrderShopsWarning", [noOrderDate]),
                          ])
                        }}
                      </v-btn>
                    </v-row>
                  </v-col>
                  <v-data-table
                    :headers="noOrderShopsHeaders"
                    :items="noOrderShops"
                    multi-sort
                    class="pb-2"
                    :footer-props="$t('$config.top-footer-props')"
                  >
                  </v-data-table>
                </v-tab-item>
                <v-tab-item v-show="settings && maxStockMaterials.length">
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    align-self="center"
                    v-if="maxStockMaterials.length > 0"
                  >
                    <v-row dense align="center" class="search-controls">
                      <v-spacer />
                      <v-btn
                        small
                        color="print"
                        dark
                        @click.stop="getStockMaterials(2)"
                        class="ms-1"
                      >
                        <v-icon x-small class="pe-1">fa-file-export</v-icon>
                        {{
                          $t("Export.export", [$t("Top.max_stock_materials")])
                        }}
                      </v-btn>
                    </v-row>
                  </v-col>
                  <v-data-table
                    :headers="maxStockMaterialsHeaders"
                    :items="maxStockMaterials"
                    multi-sort
                    class="pb-2"
                    :footer-props="$t('$config.top-footer-props')"
                  >
                    <template v-slot:item.stock_max="{ item }">
                      {{ item.stock_max | formatTwoDot }}
                    </template>
                    <template v-slot:item.stock_current_count="{ item }">
                      {{
                        $numberFormatter.formatTwoDot(
                          item.stock_current_count,
                          true
                        )
                      }}
                      {{ item.unit }}
                    </template>
                  </v-data-table>
                </v-tab-item>
                <v-tab-item v-show="settings && minStockMaterials.length">
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    align-self="center"
                    v-if="minStockMaterials.length > 0"
                  >
                    <v-row dense align="center" class="search-controls">
                      <v-spacer />
                      <v-btn
                        small
                        color="print"
                        dark
                        @click.stop="getStockMaterials(1)"
                        class="ms-1"
                      >
                        <v-icon x-small class="pe-1">fa-file-export</v-icon>
                        {{
                          $t("Export.export", [$t("Top.min_stock_materials")])
                        }}
                      </v-btn>
                    </v-row>
                  </v-col>
                  <v-data-table
                    :headers="minStockMaterialsHeaders"
                    :items="minStockMaterials"
                    multi-sort
                    class="pb-2"
                    :footer-props="$t('$config.top-footer-props')"
                  >
                    <template v-slot:item.stock_min="{ item }">
                      {{ item.stock_min | formatTwoDot }}
                    </template>
                    <template v-slot:item.stock_current_count="{ item }">
                      {{
                        $numberFormatter.formatTwoDot(
                          item.stock_current_count,
                          true
                        )
                      }}
                      {{ item.unit }}
                    </template>
                  </v-data-table>
                </v-tab-item>
                <v-tab-item v-show="settings && neardayShops.length">
                  <v-data-table
                    :headers="neardayShopsHeaders"
                    :items="neardayShops"
                    multi-sort
                    class="pb-2"
                    :footer-props="$t('$config.top-footer-props')"
                  >
                    <template v-slot:item.psi_end="{ item }">
                      {{ item.psi_end | formatDate }}
                    </template>
                    <template v-slot:item.close_expire_days="{ item }">
                      <span class="red--text">
                        {{ item.close_expire_days }}
                      </span>
                    </template>
                  </v-data-table>
                </v-tab-item>
                <v-tab-item v-show="settings && expiredShops.length">
                  <v-data-table
                    :headers="expiredShopsHeaders"
                    :items="expiredShops"
                    multi-sort
                    class="pb-2"
                    :footer-props="$t('$config.top-footer-props')"
                  >
                    <template v-slot:item.psi_end="{ item }">
                      {{ item.psi_end | formatDate }}
                    </template>
                    <template v-slot:item.close_expire_days="{ item }">
                      <span class="red--text">
                        {{ item.close_expire_days }}
                      </span>
                    </template>
                  </v-data-table>
                </v-tab-item>
              </v-tabs-items>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <ToDos class="mb-6" :todos="todos" />
          <v-card class="mb-6">
            <v-card-title>
              {{ $consts.shopName() }}
              <v-spacer />
              <v-chip small label filter class="mx-1" color="primary">
                {{ $t("$datetime.shortcuts.thisMonth") }}
              </v-chip>
            </v-card-title>
            <v-divider />
            <v-card-text class="mt-n3 pt-0 pb-1">
              <v-list-item class="px-0">
                <v-list-item-content class="justify-center">
                  <v-card-title class="justify-center">{{
                    activate_count
                  }}</v-card-title
                  >{{ $t("Top.shops.active_shops", [$consts.shopName()]) }}
                </v-list-item-content>
                <v-list-item-content class="justify-center">
                  <v-card-title class="justify-center">{{
                    new_shop_count
                  }}</v-card-title
                  >{{ $t("Top.shops.new_shops", [$consts.shopName()]) }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                class="px-0"
                v-if="settings && settings.shop_inventory_enable"
              >
                <v-list-item-content class="justify-center">
                  <v-card-title class="justify-center">{{
                    shop_psi_count
                  }}</v-card-title
                  >{{ $t("Top.shops.shop_psi_count", [$consts.shopName()]) }}
                </v-list-item-content>
                <v-list-item-content class="justify-center">
                  <v-card-title class="justify-center">{{
                    shop_psi_expire_count
                  }}</v-card-title
                  >{{
                    $t("Top.shops.shop_psi_expire_count", [$consts.shopName()])
                  }}
                </v-list-item-content>
              </v-list-item>
            </v-card-text>
          </v-card>
          <v-card>
            <v-card-title>
              {{ $t("Top.suppliers.title") }}
              <v-spacer />
              <v-chip small label filter class="mx-1" color="primary">
                {{ $t("$datetime.shortcuts.thisMonth") }}
              </v-chip>
            </v-card-title>
            <v-divider />
            <v-card-text class="mt-n3 pt-0 pb-1">
              <v-list-item class="px-0">
                <v-list-item-content class="justify-center">
                  <v-card-title class="justify-center">{{
                    supplier_activate_count
                  }}</v-card-title>
                  {{ $t("Top.suppliers.activate_count") }}
                </v-list-item-content>
                <v-list-item-content class="justify-center">
                  <v-card-title class="justify-center">{{
                    new_supplier_count
                  }}</v-card-title>
                  {{ $t("Top.suppliers.new_supplier_count") }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                class="px-0"
                v-if="settings && settings.supplier_expire_show_flg"
              >
                <v-list-item-content class="justify-center">
                  <v-card-title class="justify-center">{{
                    supplier_expire_count
                  }}</v-card-title>
                  {{ $t("Top.suppliers.expire_count") }}
                </v-list-item-content>
                <v-list-item-content class="justify-center">
                  <v-card-title class="justify-center">{{
                    supplier_notice_count
                  }}</v-card-title>
                  {{ $t("Top.suppliers.notice_count") }}
                </v-list-item-content>
              </v-list-item>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-sheet>
    <DeliveryErrDialog
      v-model="deliveryErrFlg"
      :deliveryErrors="deliveryErrors"
    />
    <v-dialog v-model="pushErrFlg" width="800px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("Top.PushError.title") }}
          <v-spacer />
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="pushErrFlg = false">
                fa-times
              </v-icon>
            </template>
            <span>{{ $t("$vuetify.close") }}</span>
          </v-tooltip>
        </v-card-title>
        <v-divider></v-divider>

        <!-- 表格 -->
        <v-data-table
          :headers="pushErrorHeaders"
          :items="pushErrors"
          multi-sort
          class="elevation-0 px-6"
          :footer-props="
            Object.assign({}, $t('$config.footer-props'), {
              itemsPerPageOptions: [5],
            })
          "
        >
          <template v-slot:item.order_code="{ item }">
            <a
              class="text-no-wrap"
              :href="
                '/#/' +
                (item.order_type == 1
                  ? 'orders'
                  : item.order_type == 2
                  ? 'return-orders'
                  : item.order_type == 3
                  ? 'stock-orders-in'
                  : item.order_type == 4
                  ? 'stock-orders-out'
                  : item.order_type == 20
                  ? 'purchase-plans/detail'
                  : 'orders') +
                '/' +
                (item.order_type == 3 || item.order_type == 4
                  ? item.stock_order_id
                  : item.order_type == 20
                  ? item.order_code + '/distribute'
                  :item.order_id)
              "
              style="text-decoration: none"
            >
              {{ item.order_code }}
            </a>
          </template>
          <template v-slot:item.err_msg="{ item }">
            <span class="red--text">
              {{ item.err_msg }}
            </span>
          </template>
        </v-data-table>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            outlined
            @click="pushErrFlg = false"
            class="elevation-1"
          >
            {{ $t("$vuetify.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="OrderToPurchaseErrorsDialog" width="800px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("Top.orderToPurchaseError.details") }}
          <v-spacer />
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="OrderToPurchaseErrorsDialog = false"
              >
                fa-times
              </v-icon>
            </template>
            <span>{{ $t("$vuetify.close") }}</span>
          </v-tooltip>
        </v-card-title>
        <v-divider></v-divider>

        <!-- 表格 -->
        <v-data-table
          :headers="OrderToPurchaseErrorDetailsHeaders"
          :items="OrderToPurchaseErrorDetails"
          multi-sort
          class="elevation-0 px-6"
          :footer-props="
            Object.assign({}, $t('$config.footer-props'), {
              itemsPerPageOptions: [5],
            })
          "
        >
        </v-data-table>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            outlined
            @click="OrderToPurchaseErrorsDialog = false"
            class="elevation-1"
          >
            {{ $t("$vuetify.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style>
.v-sheet--offset {
  top: -24px;
  position: relative;
}
</style>

<script>
var intervalRef = void 0;
var notifyDisplayed = 0;
import { mapState } from "vuex";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import ToDos from "./ToDos";
import Top from "@/api/top";
import Alerts from "@/api/alerts";
import DeliveryErrDialog from "./plugins/DeliveryErrDialog";
import Settings from "@/api/settings";
import Purchases from "@/api/purchases.js";

export default {
  name: "Home",

  components: { Breadcrumbs, ToDos, DeliveryErrDialog },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: true,
        href: "/home",
      },
    ],
    ordersCountByHourValue() {
      return this.cutHoursData(this.ordersByHour, "orders_total_count", 3);
    },
    ordersTotalByHourValue() {
      return this.cutHoursData(
        this.ordersByHour,
        "orders_total_order_price",
        3
      );
    },
    stockOrdersCountByHourValue() {
      return this.cutHoursData(this.stockOrdersByHour, "total_count", 3);
    },
    // materialTabTitles() {
    //   var titles = [];
    //   if (this.settings && this.settings.push_platform_setting) {
    //     titles.push({
    //       title: i18n.t("Top.PushError.title"),
    //     });
    //   }
    //   if (this.settings) {
    //     titles.push(
    //       { title: i18n.t("Top.nearday_materials") },
    //       { title: i18n.t("Top.expired_materials") },
    //       { title: i18n.t("Top.noOrderShopsWarning") }
    //     );

    //     if (this.maxStockMaterials.length) {
    //       titles.push({
    //         title: i18n.t("Top.max_stock_materials"),
    //       });
    //     }
    //     if (this.minStockMaterials.length) {
    //       titles.push({
    //         title: i18n.t("Top.min_stock_materials"),
    //       });
    //     }
    //     if (this.neardayShops.length) {
    //       titles.push({
    //         title: i18n.t("Top.nearday_shop_psi"),
    //       });
    //     }
    //     if (this.expiredShops.length) {
    //       titles.push({
    //         title: i18n.t("Top.expired_shop_psi"),
    //       });
    //     }
    //   }
    //   return titles;
    // },
    neardayMaterialsHeaders: () => [
      {
        text: i18n.t("Top.materialsFields.material_code"),
        align: "start",
        value: "material.material_code",
      },
      {
        text: i18n.t("Top.materialsFields.material_name"),
        align: "start",
        value: "material.material_name",
      },
      {
        text: i18n.t("Top.materialsFields.stock_name"),
        align: "center",
        value: "stock.name",
      },
      {
        text: i18n.t("Top.materialsFields.stock_max"),
        align: "center",
        value: "stock_material.stock_max",
      },
      {
        text: i18n.t("Top.materialsFields.stock_min"),
        align: "center",
        value: "stock_material.stock_min",
      },
      {
        text: i18n.t("Top.materialsFields.stock_in_order_code"),
        align: "center",
        value: "stock_in_order_code",
      },
      {
        text: i18n.t("Top.materialsFields.nearday_count"),
        align: "center",
        value: "stock_current",
      },
      {
        text: i18n.t("Top.materialsFields.nearday"),
        align: "center",
        value: "expired_date",
      },
    ],
    pushErrorHeaders: () => [
      {
        text: i18n.t("Top.PushError.pushErrorFields.order_code"),
        align: "start",
        value: "order_code",
        sortable: false,
      },
      {
        text: i18n.t("Top.PushError.pushErrorFields.err_msg"),
        align: "center",
        value: "err_msg",
        sortable: false,
      },
    ],

    errorsHeaders: () => [
      {
        text: i18n.t("Top.PushError.Fields.err_msg"),
        align: "start",
        value: "error_msg",
        sortable: false,
      },
      {
        text: i18n.t("Top.PushError.deliveryErrorFields.order_code"),
        align: "center",
        value: "order_code",
        sortable: false,
      },
      {
        text: i18n.t("Top.PushError.Fields.actions"),
        align: "end",
        value: "actions",
        sortable: false,
      },
    ],
    OrderToPurchaseErrorsHeaders: () => [
      {
        text: i18n.t("Top.orderToPurchaseError.Fields.msg"),
        align: "start",
        value: "msg",
        sortable: false,
      },
      {
        text: i18n.t("Top.orderToPurchaseError.Fields.order_code"),
        align: "center",
        value: "order_code",
        sortable: false,
      },
      {
        text: i18n.t("Top.orderToPurchaseError.Fields.actions"),
        align: "end",
        value: "actions",
        sortable: false,
      },
    ],
    OrderToPurchaseErrorDetailsHeaders: () => [
      {
        text: i18n.t("Top.orderToPurchaseError.Fields.material_code"),
        align: "start",
        value: "material_code",
        sortable: false,
      },
      {
        text: i18n.t("Top.orderToPurchaseError.Fields.material_name"),
        align: "center",
        value: "material_name",
        sortable: false,
      },
      {
        text: i18n.t("Top.orderToPurchaseError.Fields.order_unit"),
        align: "end",
        value: "order_unit",
        sortable: false,
      },
      {
        text: i18n.t("Top.orderToPurchaseError.Fields.purchase_unit"),
        align: "end",
        value: "purchase_unit",
        sortable: false,
      },
    ],
    expiredMaterialsHeaders: () => [
      {
        text: i18n.t("Top.materialsFields.material_code"),
        align: "start",
        value: "material.material_code",
      },
      {
        text: i18n.t("Top.materialsFields.material_name"),
        align: "start",
        value: "material.material_name",
      },
      {
        text: i18n.t("Top.materialsFields.stock_name"),
        align: "center",
        value: "stock.name",
      },
      {
        text: i18n.t("Top.materialsFields.stock_max"),
        align: "center",
        value: "stock_material.stock_max",
      },
      {
        text: i18n.t("Top.materialsFields.stock_min"),
        align: "center",
        value: "stock_material.stock_min",
      },
      {
        text: i18n.t("Top.materialsFields.stock_in_order_code"),
        align: "center",
        value: "stock_in_order_code",
      },
      {
        text: i18n.t("Top.materialsFields.expired_count"),
        align: "center",
        value: "stock_current",
      },
      {
        text: i18n.t("Top.materialsFields.expired"),
        align: "center",
        value: "expired_date",
      },
    ],
    noOrderShopsHeaders: () => [
      {
        text: i18n.t("Top.NoOrderShopsFields.shop_code"),
        align: "start",
        value: "shop_code",
      },
      {
        text: i18n.t("Top.NoOrderShopsFields.shop_name"),
        align: "start",
        value: "shop_name",
      },
      {
        text: i18n.t("Top.NoOrderShopsFields.shop_user_name"),
        align: "start",
        value: "shop_user_name",
      },
      {
        text: i18n.t("Top.NoOrderShopsFields.lastOrderCreated"),
        align: "start",
        value: "lastOrderCreated",
      },
      {
        text: i18n.t("Top.NoOrderShopsFields.noOrderDays"),
        align: "start",
        value: "noOrderDays",
      },
    ],
    maxStockMaterialsHeaders: () => [
      {
        text: i18n.t("Top.materialsFields.material_code"),
        align: "start",
        value: "material_code",
      },
      {
        text: i18n.t("Top.materialsFields.material_name"),
        align: "start",
        value: "material_name",
      },
      {
        text: i18n.t("Top.materialsFields.stock_name"),
        align: "center",
        value: "stock.name",
      },
      {
        text: i18n.t("Top.materialsFields.max_stock_num"),
        align: "center",
        value: "stock_max",
      },
      {
        text: i18n.t("Top.materialsFields.stock_num"),
        align: "center",
        value: "stock_current_count",
      },
    ],
    minStockMaterialsHeaders: () => [
      {
        text: i18n.t("Top.materialsFields.material_code"),
        align: "start",
        value: "material_code",
      },
      {
        text: i18n.t("Top.materialsFields.material_name"),
        align: "start",
        value: "material_name",
      },
      {
        text: i18n.t("Top.materialsFields.stock_name"),
        align: "center",
        value: "stock.name",
      },
      {
        text: i18n.t("Top.materialsFields.min_stock_num"),
        align: "center",
        value: "stock_min",
      },
      {
        text: i18n.t("Top.materialsFields.stock_num"),
        align: "center",
        value: "stock_current_count",
      },
    ],
    neardayShopsHeaders: () => [
      {
        text: i18n.t("Top.PsiShopFields.shop_code"),
        align: "start",
        value: "shop_code",
      },
      {
        text: i18n.t("Top.PsiShopFields.shop_name"),
        align: "start",
        value: "shop_name",
      },
      {
        text: i18n.t("Top.PsiShopFields.psi_end"),
        align: "center",
        value: "psi_end",
      },
      {
        text: i18n.t("Top.PsiShopFields.nearday"),
        align: "center",
        value: "close_expire_days",
      },
    ],
    expiredShopsHeaders: () => [
      {
        text: i18n.t("Top.PsiShopFields.shop_code"),
        align: "start",
        value: "shop_code",
      },
      {
        text: i18n.t("Top.PsiShopFields.shop_name"),
        align: "start",
        value: "shop_name",
      },
      {
        text: i18n.t("Top.PsiShopFields.psi_end"),
        align: "center",
        value: "psi_end",
      },
      {
        text: i18n.t("Top.PsiShopFields.expired"),
        align: "center",
        value: "close_expire_days",
      },
    ],
    intelligenceReportsUrl() {
      return (
        this.$ReportURL +
        localStorage.getItem("accessToken") +
        "/" +
        encodeURIComponent(
          (this.reportType == 1
            ? "/shop-sales?created_date="
            : this.reportType == 2
            ? "/distribution-material-analyze?created_date="
            : "") + new Date(new Date().getTime()).toISOString().substr(0, 10)
        )
      );
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["accountInfo", "todos", "settings"]),
  },

  data: () => ({
    labels: [
      "0:00",
      "3:00",
      "6:00",
      "9:00",
      "12:00",
      "15:00",
      "18:00",
      "21:00",
    ],
    ordersTotal: {},
    ordersByHour: null,
    stockOrdersTotal: {},
    stockOrdersByHour: null,
    tab: null,
    errtab: null,
    pushErrors: [],
    deliveryErrors: [],
    neardayMaterials: [],
    expiredMaterials: [],
    maxStockMaterials: [],
    minStockMaterials: [],
    activate_count: 0,
    new_shop_count: 0,
    shop_psi_count: 0,
    shop_psi_expire_count: 0,
    snackbar: true,
    timeSnackbar: true,
    smsSnackbar: true,
    alerts: [],
    neardayShops: [],
    expiredShops: [],
    noOrderShops: [],
    supplier_activate_count: 0,
    new_supplier_count: 0,
    supplier_expire_count: 0,
    supplier_notice_count: 0,
    deliveryErrFlg: false,
    pushErrFlg: false,
    Errors: [],
    OrderToPurchaseErrors: [],
    noOrderDate: 30,
    edit_date_flg: false,
    OrderToPurchaseErrorsDialog: false,
    OrderToPurchaseErrorDetails: [],
    reportType: null,
  }),

  mounted() {
    this.refresh();
    this.refreshMaterials();
    this.refreshShops();
    this.refreshSuppliers();
    this.refreshOrderToPurchaseErrors();
    this.refreshTodos();
    this.refreshShopPsi();
    this.refreshnNOrderShops();
    this.refreshErrors();
    intervalRef = setInterval(() => {
      if (!notifyDisplayed) {
        this.refresh();
      }
    }, 5000);
  },

  methods: {
    refresh() {
      this.refreshOrders();
      this.refreshAlerts();
    },
    refreshOrders() {
      Top.orders().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.ordersTotal = response.data.orders_total;
            this.ordersByHour = response.data.orders_by_hour;
          }
        }.bind(this)
      );
    },
    refreshnNOrderShops(stopFlg) {
      var data = { no_order_date: this.noOrderDate };
      if (stopFlg) {
        data = Object.assign({}, data, { shop_status_stop: 1 });
      }
      Top.noOrderShopsWarning(data).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.noOrderShops = response.data.shops;
            if (stopFlg) {
              this.refreshnNOrderShops();
            }
          }
        }.bind(this)
      );
    },
    refreshAlerts() {
      Alerts.fetch({ state_flgs: [0] }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.alerts = response.data.alerts;
          }
        }.bind(this)
      );
    },
    refreshMaterials() {
      Top.materials({ type: 2 }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.neardayMaterials = response.data.materials;
            Top.materials({ type: 1 }).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.expiredMaterials = response.data.materials;
                }
              }.bind(this)
            );
          }
        }.bind(this)
      );

      Top.stockMaterials({ type: 2 }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.maxStockMaterials = response.data.materials;
            Top.stockMaterials({ type: 1 }).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.minStockMaterials = response.data.materials;
                }
              }.bind(this)
            );
          }
        }.bind(this)
      );
    },
    refreshShops() {
      Top.shops().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.activate_count = response.data.activate_count;
            this.new_shop_count = response.data.new_shop_count;
          }
        }.bind(this)
      );
    },
    refreshSuppliers() {
      Top.suppliers().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.supplier_activate_count = response.data.activate_count;
            this.new_supplier_count = response.data.new_supplier_count;
            this.supplier_expire_count = response.data.expire_count;
            this.supplier_notice_count = response.data.notice_count;
          }
        }.bind(this)
      );
    },
    refreshTodos() {
      Top.todos();
    },
    refreshShopPsi() {
      Top.getNeardayShops().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.neardayShops = response.data.shops;
          }
        }.bind(this)
      );
      Top.getExpiredShops().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.expiredShops = response.data.shops;
          }
        }.bind(this)
      );
      Top.getShopPsiCount().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.shop_psi_count = response.data.shop_psi_count;
            this.shop_psi_expire_count = response.data.shop_psi_expire_count;
          }
        }.bind(this)
      );
    },
    cutHoursData(data, tag, hours) {
      if (!data) return [0, 0, 0, 0, 0, 0, 0, 0];
      var cutted = [];
      var i = 0;
      var c = 0;
      Object.values(data).forEach((d) => {
        if (i >= hours) {
          cutted.push(c);
          i = 0;
          c = 0;
        }
        c += Number(d[tag]);
        i++;
      });
      cutted.push(c);
      return cutted;
    },
    getMaterials(type) {
      Top.getMaterials({ type: type });
    },
    getStockMaterials(type) {
      Top.getStockMaterials({ type: type });
    },
    noOrderShopsWarningExport() {
      Top.noOrderShopsWarningExport({ no_order_date: this.noOrderDate });
    },
    refreshErrors() {
      this.Errors = [];
      if (this.settings && this.settings.push_platform_setting) {
        Top.getPushErr().then(
          function (response) {
            if (response.data.status.isOK()) {
              this.pushErrors = response.data.push_platform_errors;
              if (this.pushErrors.length) {
                this.Errors.push({
                  error_msg: i18n.t("Top.PushError.push_platform_errors"),
                  type: 1, //推单失败
                });

                this.tab = 0;
              }
            }
          }.bind(this)
        );
      }
      Top.getGenerateDeliveryErr().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.deliveryErrors = [];
            if (response.data.delivery_errors.length) {
              this.deliveryErrors.push({
                errors: response.data.delivery_errors,
                error_msg: i18n.t("Top.PushError.delivery_errors"),
              });
              this.Errors.push({
                error_msg: i18n.t("Top.PushError.delivery_errors"),
                type: 2, //分发出错
              });
              this.tab = 0;
            }
            if (
              (!localStorage.getItem("errorAlertDate") ||
                localStorage.getItem("errorAlertDate") < new Date()) &&
              response.data.delivery_errors.length
            ) {
              //限制提醒弹窗一天只弹出一次
              this.deliveryErrFlg = true;
              localStorage.setItem(
                "errorAlertDate",
                new Date(new Date().getTime() + 24 * 3600 * 1000).setHours(
                  0,
                  0,
                  0,
                  0
                )
              );
            }
          }
        }.bind(this)
      );
    },
    refreshOrderToPurchaseErrors() {
      this.OrderToPurchaseErrors = [];
      if (
        this.settings &&
        this.settings.order_to_purchase_unit_error_edit_num
      ) {
        Purchases.orderToPurchaseError().then(
          function (response) {
            if (response.data.status.isOK()) {
              this.OrderToPurchaseErrors =
                response.data.order_to_purchase_errors;
              this.tab = 1;
            }
          }.bind(this)
        );
      }
    },
    orderToPurchaseErrorView(id) {
      if (
        this.settings &&
        this.settings.order_to_purchase_unit_error_edit_num
      ) {
        Purchases.orderToPurchaseErrorView(id).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.OrderToPurchaseErrorDetails =
                response.data.order_to_purchase_errors;
              this.OrderToPurchaseErrorsDialog = true;
            }
          }.bind(this)
        );
      }
    },
    saveNoOrderDate() {
      Settings.batchSave([
        {
          setting_key: "no_order_date",
          setting_value: this.noOrderDate,
        },
      ]).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$snackbar.success(i18n.t("BusinessSetting.saveSuccess"));
            this.getSettings();
            this.refreshnNOrderShops();
            this.edit_date_flg = false;
          }
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
    },
    getSettings() {
      Settings.getSettings({
        keys: ["no_order_date"],
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            if (!response.data.settings.no_order_date) {
              this.noOrderDate = 30;
            } else {
              this.noOrderDate = response.data.settings.no_order_date;
            }
          }
        }.bind(this)
      );
    },
  },
  watch: {
    Errors: {
      handler() {
        if (this.tab == 0 && !this.Errors.length) {
          this.tab = 1;
        }
      },
    },
    OrderToPurchaseErrors: {
      handler() {
        if (this.tab == 1 && !this.OrderToPurchaseErrors.length) {
          this.tab = 2;
        }
      },
    },
    settings: {
      handler() {
        this.refreshErrors();
        this.noOrderDate = this.settings.no_order_date
          ? this.settings.no_order_date
          : 30;
        this.refreshnNOrderShops();
        this.refreshOrderToPurchaseErrors();
      },
    },
  },

  beforeDestroy() {
    clearInterval(intervalRef);
    intervalRef = void 0;
  },
};
</script>
